<script>
export default {
    data() {
        return {
            visible: false
        };
    },
    methods: {
        reveal() {
            this.visible = true;
        }
    }
};
</script>

<template>
    <div>
        <template name="fade" mode="out-in">
            <button class="btn btn-purple fullWidth xLarge" @click="reveal" v-if="!visible">
                <slot name="buttonText">Reveal content</slot>
            </button>

            <div v-if="visible">
                <slot></slot>
            </div>
        </template>
    </div>
</template>
